// import Swiper from "swiper"
import { qq, q } from "../../helper/q"
import { Swiper, Navigation } from "swiper/dist/js/swiper.esm.js"
Swiper.use([Navigation])
let sliders = []

export const productSliderInit = () => {
  if (matchMedia) {
    const mq = window.matchMedia("(min-width: 992px)")
    mq.addListener(WidthChange)
    WidthChange(mq)
  }
}

const WidthChange = mq => {
  const sliderElements = qq(".productSlider")
  if (sliderElements) {
    if (mq.matches) {
      sliders = sliderElements.map(sliderElement => {
        return new Swiper(sliderElement, {
          slidesPerView: "5",
          spaceBetween: 33,
          loop: false,
          navigation: {
            prevEl: q(".productSliderButtonPrev", sliderElement.parentNode),
            nextEl: q(".productSliderButtonNext", sliderElement.parentNode),
            disabledClass: "productSliderButtonDisabled"
          },
          breakpoints: {
            1680: {
              slidesPerView: 4
            },
            1200: {
              slidesPerView: 3
            },
            992: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: "auto"
            }
          }
        })
      })
    } else {
      sliders.map((slider, index) => {
        sliders[index] !== undefined && sliders[index].destroy(true, true)
        // if (slider.swiper) slider.swiper.destroy(true, true)
      })
    }
  }
}
